/**
 * Reserves the tallest Ask Simply tab panel's height so the card doesn't resize on tab switch.
 * Markup: partials/vertical-lp/ask-simply-section.html.twig; required by every entry rendering it.
 * Off on mobile (≤767).
 */
function initReserveTallestTabPanel() {
    const wraps = document.querySelectorAll(".ask-simply__tabs .tabs-panels");

    wraps.forEach(function (wrap) {
        const panels = Array.from(wrap.querySelectorAll(".tabs-panel"));
        if (!panels.length) {
            return;
        }

        let measuring = false;

        function reserveTallestPanel() {
            if (measuring) {
                return;
            }
            measuring = true;
            wrap.style.minHeight = "";
            if (window.matchMedia("(max-width: 767px)").matches) {
                wrap.style.minHeight = "";
                measuring = false;
                return;
            }
            let tallest = 0;
            panels.forEach(function (panel) {
                const wasHidden = panel.hasAttribute("hidden");
                const wasInactive = !panel.classList.contains("active");
                if (wasHidden) {
                    panel.removeAttribute("hidden");
                }
                if (wasInactive) {
                    panel.classList.add("active", "in");
                }
                if (wasHidden) {
                    panel.style.cssText =
                        "position:absolute;top:0;left:0;width:100%;visibility:hidden";
                }
                tallest = Math.max(tallest, panel.offsetHeight);
                if (wasHidden) {
                    panel.style.cssText = "";
                }
                if (wasInactive) {
                    panel.classList.remove("active", "in");
                }
                if (wasHidden) {
                    panel.setAttribute("hidden", "until-found");
                }
            });
            wrap.style.minHeight = tallest + "px";
            measuring = false;
        }

        reserveTallestPanel();
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(reserveTallestPanel);
        }
        if (window.ResizeObserver) {
            new ResizeObserver(reserveTallestPanel).observe(wrap);
        }
    });
}

module.exports = { initReserveTallestTabPanel };
